

















































































































































import Vue from 'vue';
import VueCompositionAPI, {defineComponent} from '@vue/composition-api';
import {MarkerComponent} from '@mobi-components/global-google-map-components';
import PlaceWithSchedule from '../solution-views/explore-view/place-with-schedule.vue';
// @ts-ignore
import ArrowDown from '@components/svg/arrow-down.vue';
import {VPopover, VClosePopover} from 'v-tooltip';
import {commonExploreView, ExploreArgs} from '@components/solution-views/explore-view/common-explore-view';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {SchedulePopover, RadioInput} from '@mobi-components/amex-poi-details-view';
import '@mobi-components/amex-poi-details-view/dist/amex-poi-details-view.css';

Vue.use(VueCompositionAPI);

export interface PropTypes {
  selectedDay: number;
  category: UserActivityCategoryEnum;
}

const AmexMarkersCollection = defineComponent({
  components: {
    PlaceWithSchedule,
    MarkerComponent,
    ArrowDown,
    VPopover,
    SchedulePopover,
    RadioInput,
  },
  directives: {
    'close-popover': VClosePopover,
  },
  props: {
    markers: Array,
    updateTrigger: String,
    selectedDay: {
      type: Number,
      default: 0,
    },
    category: {
      type: String,
      required: true,
    },
  },
  setup(props, v) {
    return commonExploreView(props as PropTypes, (v as unknown) as ExploreArgs);
  },
});

export default AmexMarkersCollection;
